// SPDX-License-Identifier: AGPL-3.0-or-later

import type {GameOverlayAnchor, GameOverlayMode} from '@app/features/game_overlay/utils/GameOverlayModel';
import {makePersistent} from '@app/features/platform/utils/MobXPersistence';
import type {DesktopGameOverlayCorner} from '@app/types/electron.d';
import {makeAutoObservable} from 'mobx';

class GameOverlaySettingsState {
	enabled = false;
	mode: GameOverlayMode = 'speaking';
	corner: DesktopGameOverlayCorner = 'top-left';
	scale = 100;
	offsetX = 0;
	offsetY = 0;
	displayId: string | null = null;
	onlyInGame = false;

	constructor() {
		makeAutoObservable(this, {}, {autoBind: true});
		void makePersistent(this, 'GameOverlaySettings', [
			'enabled',
			'mode',
			'corner',
			'scale',
			'offsetX',
			'offsetY',
			'displayId',
			'onlyInGame',
		]);
	}

	setEnabled(enabled: boolean): void {
		this.enabled = enabled;
	}

	setMode(mode: GameOverlayMode): void {
		this.mode = mode;
	}

	setCorner(corner: DesktopGameOverlayCorner): void {
		this.setAnchor({corner, offsetX: 0, offsetY: 0});
	}

	setAnchor({corner, offsetX, offsetY}: GameOverlayAnchor): void {
		this.corner = corner;
		this.offsetX = offsetX;
		this.offsetY = offsetY;
	}

	setScale(scale: number): void {
		this.scale = scale;
	}

	setDisplayId(displayId: string | null): void {
		this.displayId = displayId;
	}

	setOnlyInGame(onlyInGame: boolean): void {
		this.onlyInGame = onlyInGame;
	}
}

export default new GameOverlaySettingsState();
